/**
 * URL publique de l’API : runtime-config.js (conteneur) > build Vite > hostname qualif/prod.
 * Ne jamais fallback silencieusement vers la prod si on est sur un host qualif.
 */
import { getBrowserHostname, isQualifEnvironment } from './environment';

const HOST_API_MAP: Record<string, string> = {
  'app.inventwee.com': 'https://api.inventwee.com',
  'inventwee.airzk.fr': 'https://api.inventwee.airzk.fr',
  'qa001.inventwee.airzk.fr': 'https://qa001.api.inventwee.airzk.fr',
  'inventwee-qualif.airzk.fr': 'https://qa001.api.inventwee.airzk.fr',
};

const QUALIF_API_DEFAULT = 'https://qa001.api.inventwee.airzk.fr';
const PROD_API_DEFAULT = 'https://api.inventwee.com';

function normalizeUrl(url: string): string {
  return url.replace(/\/$/, '');
}

function apiFromHostname(hostname: string | undefined): string | undefined {
  if (!hostname) return undefined;
  const key = hostname.toLowerCase();
  return HOST_API_MAP[key];
}

/** Rejette une URL API prod si le front est servi depuis la qualif. */
function guardQualifApiUrl(url: string): string {
  const hostname = getBrowserHostname();
  if (!hostname || !isQualifEnvironment()) {
    return url;
  }
  const lower = url.toLowerCase();
  const looksLikeProd =
    lower.includes('api.inventwee.com') ||
    lower.includes('api.inventwee.airzk.fr');
  if (looksLikeProd) {
    console.warn(
      '[InventWee] URL API prod détectée sur un front qualif — bascule vers',
      QUALIF_API_DEFAULT,
    );
    return QUALIF_API_DEFAULT;
  }
  return url;
}

export function getApiBaseUrl(): string {
  const w = typeof window !== 'undefined' ? window : undefined;
  const runtime = w && (w as Window & { __INVENTWEE_API_URL__?: string }).__INVENTWEE_API_URL__;
  const trimmed = runtime != null && String(runtime).trim() !== '' ? String(runtime).trim() : '';
  if (trimmed) {
    return normalizeUrl(guardQualifApiUrl(trimmed));
  }

  const fromBuild = import.meta.env.VITE_API_URL;
  if (fromBuild && String(fromBuild).trim() !== '') {
    return normalizeUrl(guardQualifApiUrl(String(fromBuild)));
  }

  const fromHost = apiFromHostname(w?.location?.hostname);
  if (fromHost) {
    return fromHost;
  }

  if (isQualifEnvironment()) {
    return QUALIF_API_DEFAULT;
  }

  return 'http://localhost:4001';
}

export function getExpectedFrontendOrigin(): string | undefined {
  const hostname = getBrowserHostname();
  if (!hostname) return undefined;
  return `https://${hostname}`;
}
